module.exports = __webpack_public_path__ + "img/Flag_of_Azerbaijan.81f32e58.svg";